import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import LogoType from 'assets/img';
import colors from 'scss/variables/colors.module.scss'

const buildType = window.REACT_APP_BUILD_TYPE !== 'REPLACE_REACT_APP_BUILD_TYPE' ? window.REACT_APP_BUILD_TYPE : process.env.REACT_APP_BUILD_TYPE || 'simple';

type SpinnerType = {
  size?: string | number;
  color?: string;
  width?: string;
  withLogo?: boolean;
  height?: string | number;
};

const Spinner = ({ size = 25, color = 'inherit', width = '100%', withLogo, height = '100%' }: SpinnerType) => {
  const type = buildType?.toLocaleLowerCase()?.trim()
  const isEnterprise = type === 'enterprise';
  const brandedColor = isEnterprise ? colors.black : colors.primary100
  const currentColor = color ? color : brandedColor
  const antIcon = <LoadingOutlined style={{ fontSize: size, color: currentColor }} spin />;
  return (
    <div
      style={{
        width,
        height: height,
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Spin indicator={antIcon} />

      {withLogo && <img
        style={{
          position: 'absolute',
          height: 'auto',
          width: Number(size) * .6,
        }}
        src={LogoType}
        alt='logoIcon'
      />}

    </div>
  );
};

export default Spinner;
